import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { of } from 'rxjs';

import { LocalStorageService } from '@cash/shared/local-storage';

import {
    dictionaryChange,
    languageChange,
} from '../state';
import { LOCAL_STORAGE_PREFIX } from '../constants';

@Injectable()
export class DictionaryReactiveService {
    constructor(
        private readonly localStorageService: LocalStorageService,
        private readonly translateService: TranslateService,
        private readonly store: Store,
    ) {
    }

    public initialize() {
        this.onLocalStorageChanges();
        this.onTranslationChanges();

        const languageCode = this.localStorageService.get('languageCode');

        if (!languageCode) {
            return of(null);
        }

        return this.translateService.use(languageCode);
    }

    private onTranslationChanges() {
        this.translateService.onTranslationChange
            .subscribe(() =>
                this.store.dispatch(dictionaryChange()),
            );

        this.translateService.onLangChange.subscribe(() => this.store.dispatch(languageChange()));
    }

    private onLocalStorageChanges() {
        this.localStorageService.changes
            .pipe(
                filter((storage) => !!storage.key),
                filter((storage) => storage.key.includes(LOCAL_STORAGE_PREFIX)),
            )
            .subscribe((storage) => {
                const lang = storage.key.split('_')[1];

                this.translateService.setTranslation(
                    lang,
                    this.extractTranslationsFromResponse(storage.value),
                    true,
                );
            });
    }

    private readonly extractTranslationsFromResponse = (response): Record<string, string> =>
        response?.reduce(
            (
                map,
                obj,
            ) => {
                if (obj.dictionary && obj.module) map[obj.module] = obj.dictionary;
                return map;
            },
            {},
        );
}
